<template>
  <div id="mapContainer"></div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'

export default {
  name: 'Map',
  mounted () {
    // 重置API加载状态
    AMapLoader.reset()
    //
    AMapLoader.load({
      key: 'ef3de55fc51c2bfd2ac3e917e8891131', // 替换为你的API Key
      version: '2.0', // 指定API版本号
      plugins: ['AMap.Marker'] // 需要使用的插件列表，添加Marker插件
    }).then(AMap => {
      const map = new AMap.Map('mapContainer', {
        center: [116.749696, 39.594218], // 设置地图中心点坐标为116.754513, 39.590168
        zoom: 15// 缩放级别
      })

      // 创建一个标记，并设置为可拖拽
      const marker = new AMap.Marker({
        position: new AMap.LngLat(116.749696, 39.594218), // 标记的位置为116.754513, 39.590168
        map: map, // 将标记添加到地图上
        title: '可拖拽标记', // 鼠标滑过标记时显示的标题
        draggable: true // 设置标记可拖拽
      })
      // 为标记添加拖拽事件监听
      marker.on('dragend', function (event) {
        console.log('拖拽结束后的经纬度坐标：', event.lnglat)
      })
    }).catch(e => {
      console.error(e)
    })
  }
}
</script>

<style scoped lang="less">
#mapContainer {
  width: 800px;
  height: 600px; /* 根据需要设置高度 */
}
</style>



// WEBPACK FOOTER //
// src/components/Map/Map.vue